import { render } from "./ClasificationList.vue?vue&type=template&id=5f025e63&scoped=true"
import script from "./ClasificationList.vue?vue&type=script&lang=js"
export * from "./ClasificationList.vue?vue&type=script&lang=js"

import "./ClasificationList.vue?vue&type=style&index=0&id=5f025e63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f025e63"]])

export default __exports__